var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.mainWidth >= 900)?_c('PC'):_c('H5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }